export default {
  THIRD_BLANK_GAME: {
    name: 'بازی جای خالی سوم',
    type: 'THIRD_BLANK_GAME',
    url: '/games/THIRD_BLANK_GAME/',
  },
  SECOND_BLANK_GAME: {
    name: 'بازی جای خالی دوم',
    type: 'SECOND_BLANK_GAME',
    url: '/games/SECOND_BLANK_GAME/',
  },
  FIRST_BLANK_GAME: {
    name: 'بازی جای خالی اول',
    type: 'FIRST_BLANK_GAME',
    url: '/games/FIRST_BLANK_GAME/',
  },
  MAP_GAME: {
    name: 'بازی نقاله و نقشه',
    type: 'MAP_GAME',
    url: '/games/MAP_GAME/',
  },
  GAME_THEORY_GRAPH: {
    name: 'بازی ترافیک ',
    type: 'GAME_THEORY_GRAPH',
    url: '/games/GAME_THEORY_GRAPH/',
  },
  FIRST_TRAFFIC_GAME: {
    name: 'بازی ترافیک اول',
    type: 'FIRST_TRAFFIC_GAME',
    url: '/games/FIRST_TRAFFIC_GAME/',
  },
  SECOND_TRAFFIC_GAME: {
    name: 'بازی ترافیک دوم',
    type: 'SECOND_TRAFFIC_GAME',
    url: '/games/SECOND_TRAFFIC_GAME/',
  },
  THIRD_TRAFFIC_GAME: {
    name: 'بازی ترافیک سوم',
    type: 'THIRD_TRAFFIC_GAME',
    url: '/games/THIRD_TRAFFIC_GAME/',
  },
  PIPELINE_GRAPH: {
    name: 'بازی شار',
    type: 'PIPELINE_GRAPH',
    url: '/games/PIPELINE_GRAPH/',
  },
  SECOND_PIPELINE_GRAPH: {
    name: 'بازی شار دوم',
    type: 'SECOND_PIPELIINE_GRAPH',
    url: '/games/SECOND_PIPELIINE_GRAPH/',
  },
  DORM_GAME: {
    name: 'بازی خوابگاه',
    type: 'DORM_GAME',
    url: '/games/DORM_GAME/',
  },
  FIRST_BLOCKCHAIN: {
    name: 'بلاکچین اول',
    type: 'FIRST_BLOCKCHAIN',
    url: '/games/FIRST_BLOCKCHAIN/',
  },
  SECOND_BLOCKCHAIN: {
    name: 'بلاکچین دوم',
    type: 'SECOND_BLOCKCHAIN',
    url: '/games/SECOND_BLOCKCHAIN/',
  },
  DUMMIES_GAME: {
    name: 'بازی آدمک‌‌ها',
    type: 'DUMMIES_GAME',
    url: '/games/DUMMIES_GAME/',
  },
  VERTICAL_LINES: {
    name: 'خط‌های عمودی',
    type: 'VERTICAL_LINES',
    url: '/games/VERTICAL_LINES/',
  },
  FIRST_BOX_GAME: {
    name: 'جعبه‌ها و ماشین‌ها اول',
    type: 'FIRST_BOX_GAME',
    url: '/games/FIRST_BOX_GAME/',
  },
  SECOND_BOX_GAME: {
    name: 'جعبه‌ها و ماشین‌ها دوم',
    type: 'SECOND_BOX_GAME',
    url: '/games/SECOND_BOX_GAME/',
  },
  FIRST_DRIVIING_CAR: {
    name: 'ماشین خودران اول',
    type: 'FIRST_DRIVIING_CAR',
    url: '/games/FIRST_DRIVIING_CAR/',
  },
  SECOND_DRIVIING_CAR: {
    name: 'ماشین خودران دوم',
    type: 'SECOND_DRIVIING_CAR',
    url: '/games/SECOND_DRIVIING_CAR/',
  },
  GRID: {
    name: 'شبکه نقاط',
    type: 'GRID',
    url: '/games/GRID/',
  },
  RENT_ROOM: {
    name: 'اجاره اتاق',
    type: 'RENT_ROOM',
    url: '/games/RENT_ROOM/',
  },
  FIRST_CODING_GAME: {
    name: 'بازی اول کدینگ',
    type: 'FIRST_CODING_GAME',
    url: '/games/FIRST_CODING_GAME/',
  },
  SECOND_CODING_GAME: {
    name: 'بازی دوم کدینگ',
    type: 'SECOND_CODING_GAME',
    url: '/games/SECOND_CODING_GAME/',
  },
  GEOGEBRA: {
    name: 'جئوجبرا',
    type: 'GEOGEBRA',
    url: '/games/GEOGEBRA/',
  },
  STREET_GRAPH: {
    name: 'گراف خیابان',
    type: 'STREET_GRAPH',
    url: '/games/STREET_GRAPH/',
  },
  FREE_FALL: {
    name: 'سقوط آزاد',
    type: 'FREE_FALL',
    url: '/games/FREE_FALL/',
  },
  SPACE_GAME: {
    name: 'نمودار',
    type: 'SPACE_GAME',
    url: '/games/SPACE_GAME/',
  },
  X_QUESTIONS: {
    name: 'چند سوالی',
    type: 'X_QUESTIONS',
    url: '/games/X_QUESTIONS/',
  },
  HASH: {
    name: 'هش',
    type: 'HASH',
    url: '/games/HASH/',
  },
  BLOCK: {
    name: 'بلاک',
    type: 'BLOCK',
    url: '/games/BLOCK/',
  },
  BLOCKCHAIN: {
    name: 'بلاک‌چین',
    type: 'BLOCKCHAIN',
    url: '/games/BLOCKCHAIN/',
  },
  MESSAGE_GAME: {
    name: 'پیغام بازی',
    type: 'MESSAGE_GAME',
    url: '/games/MESSAGE_GAME/',
  },
  AUCTION_GAME1: {
    name: 'مزایده',
    type: 'AUCTION_GAME1',
    url: '/games/AUCTION_GAME1/',
  },
  AUCTION_GAME2: {
    name: 'مزایده',
    type: 'AUCTION_GAME2',
    url: '/games/AUCTION_GAME2/',
  },
  AUCTION_GAME3: {
    name: 'مزایده',
    type: 'AUCTION_GAME3',
    url: '/games/AUCTION_GAME3/',
  },
  AUCTION_GAME4: {
    name: 'مزایده',
    type: 'AUCTION_GAME4',
    url: '/games/AUCTION_GAME4/',
  },
};
